var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import { BaseCheckpointModel } from '../BaseCheckpointModel';
export const initialState = {
    id: `${new Date().getTime()}`,
    county: '',
    municipality: '',
    unitDesignation: '',
    type: '',
    numberOfOwner: 0,
    ownershipPercentage: 0,
    totalArea: 0
};
export class PropertyOwnershipCheckpoint extends BaseCheckpointModel {
    constructor(checkpoint) {
        super(checkpoint);
        Object.assign(this, checkpoint);
        this.properties.map((property, index) => {
            property.id = `${index}_${new Date().getTime()}`;
        });
    }
    toJson() {
        return {
            properties: this.properties,
            numberOfProperties: this.numberOfProperties,
            assessedTotal: this.assessedTotal,
            assessedOfBuilding: this.assessedOfBuilding,
            assessedOfLand: this.assessedOfLand,
            assessedOfOwnedPart: this.assessedOfOwnedPart,
            type: this.type,
            comment: this.comment,
            discrepancy: this.discrepancy,
            researcherId: this.researcherId,
            verificationDate: this.calculateVerificationDate()
        };
    }
}
PropertyOwnershipCheckpoint.initialState = initialState;
__decorate([
    observable
], PropertyOwnershipCheckpoint.prototype, "properties", void 0);
__decorate([
    observable
], PropertyOwnershipCheckpoint.prototype, "numberOfProperties", void 0);
__decorate([
    observable
], PropertyOwnershipCheckpoint.prototype, "assessedTotal", void 0);
__decorate([
    observable
], PropertyOwnershipCheckpoint.prototype, "assessedOfBuilding", void 0);
__decorate([
    observable
], PropertyOwnershipCheckpoint.prototype, "assessedOfLand", void 0);
__decorate([
    observable
], PropertyOwnershipCheckpoint.prototype, "assessedOfOwnedPart", void 0);
__decorate([
    action
], PropertyOwnershipCheckpoint.prototype, "toJson", null);
